function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { deepEqual, getKeys } from '@bydesign-ui/utils';
import { Emitter } from '@bydesign-ui/hooks';
export var AutoComplete = function (_Emitter) {
  _inherits(AutoComplete, _Emitter);

  var _super = _createSuper(AutoComplete);

  function AutoComplete() {
    var _this;

    _classCallCheck(this, AutoComplete);

    _this = _super.apply(this, arguments);
    _this.keyword = '';
    _this.activeIndex = null;
    _this.multiple = false;
    _this.checkable = true;
    _this.disabled = false;
    _this.allowClear = false;
    _this.showEmpty = false;
    _this.selectedValue = [];
    _this.dataSource = [];
    return _this;
  }

  _createClass(AutoComplete, [{
    key: "updateOptions",
    value: function updateOptions(options) {
      var _this2 = this;

      getKeys(options).forEach(function (key) {
        if (options[key] !== undefined) {
          Object.assign(_this2, _defineProperty({}, key, options[key]));
        }
      });
    }
  }, {
    key: "getRenderSearchItem",
    value: function getRenderSearchItem() {
      return this.renderSearchItem;
    }
  }, {
    key: "reset",
    value: function reset() {
      this.activeIndex = null;

      if (this.multiple) {
        this.keyword = '';
      }
    }
  }, {
    key: "onClear",
    value: function onClear() {
      this.keyword = '';
      this.activeIndex = null;
      this.selectedValue = [];
      this.emit('on-select', [], []);
      this.update();
    }
  }, {
    key: "onKeywordChange",
    value: function onKeywordChange(keyword) {
      this.keyword = keyword;
      this.emit('on-search', keyword);
      this.update();
    }
  }, {
    key: "handleSelect",
    value: function handleSelect(chooseData) {
      if (this.multiple) {
        var originData = _toConsumableArray(this.selectedValue);

        var notExist = this.selectedValue.every(function (item, index) {
          var isEqual = deepEqual(chooseData.value, item.value);
          isEqual && originData.splice(index, 1);
          return !isEqual;
        });
        notExist && originData.push(chooseData);
        var filterData = originData.map(function (item) {
          return item.value;
        });
        this.selectedValue = originData;
        this.emit('on-select', filterData, originData);
      } else {
        this.keyword = chooseData.label;
        this.emit('on-select', [chooseData.value], [chooseData]);
      }

      this.update();
    }
  }, {
    key: "getFilterData",
    value: function getFilterData() {
      var _this3 = this;

      return this.dataSource.filter(function (item) {
        return _this3.filterOption(_this3.keyword, item);
      });
    }
  }, {
    key: "selectBackFill",
    value: function selectBackFill() {
      if (this.activeIndex === null) {
        return;
      }

      var filterData = this.getFilterData();
      filterData.length > 0 && this.handleSelect(filterData[this.activeIndex]);
    }
  }, {
    key: "stepDown",
    value: function stepDown() {
      var length = this.getFilterData().length;

      if (this.disabled) {
        return;
      }

      if (this.activeIndex === null) {
        this.activeIndex = 0;
      } else {
        if (this.activeIndex + 1 > length - 1) {
          this.activeIndex = 0;
        } else {
          this.activeIndex += 1;
        }
      }

      this.update();
    }
  }, {
    key: "stepUp",
    value: function stepUp() {
      var length = this.getFilterData().length;

      if (this.disabled) {
        return;
      }

      if (this.activeIndex === null) {
        this.activeIndex = 0;
      } else {
        if (this.activeIndex - 1 < 0) {
          this.activeIndex = length - 1;
        } else {
          this.activeIndex -= 1;
        }
      }

      this.update();
    }
  }, {
    key: "filterOption",
    value: function filterOption(keyword, item) {
      return item.label.toLowerCase().includes(keyword.toLowerCase());
    }
  }, {
    key: "update",
    value: function update() {
      this.emit('update');
    }
  }]);

  return AutoComplete;
}(Emitter);